export * from './aPIKeysController.service';
import { APIKeysControllerService } from './aPIKeysController.service';
export * from './assetsController.service';
import { AssetsControllerService } from './assetsController.service';
export * from './balancesController.service';
import { BalancesControllerService } from './balancesController.service';
export * from './candlesController.service';
import { CandlesControllerService } from './candlesController.service';
export * from './customSettingController.service';
import { CustomSettingControllerService } from './customSettingController.service';
export * from './depositController.service';
import { DepositControllerService } from './depositController.service';
export * from './fiatDepositInstructionController.service';
import { FiatDepositInstructionControllerService } from './fiatDepositInstructionController.service';
export * from './loginController.service';
import { LoginControllerService } from './loginController.service';
export * from './ordersController.service';
import { OrdersControllerService } from './ordersController.service';
export * from './pairsController.service';
import { PairsControllerService } from './pairsController.service';
export * from './reportingController.service';
import { ReportingControllerService } from './reportingController.service';
export * from './strategyController.service';
import { StrategyControllerService } from './strategyController.service';
export * from './subaccountTransferController.service';
import { SubaccountTransferControllerService } from './subaccountTransferController.service';
export * from './tradingController.service';
import { TradingControllerService } from './tradingController.service';
export * from './transfersController.service';
import { TransfersControllerService } from './transfersController.service';
export * from './user2FAController.service';
import { User2FAControllerService } from './user2FAController.service';
export * from './userController.service';
import { UserControllerService } from './userController.service';
export * from './webSocketMessageTypes.service';
import { WebSocketMessageTypesService } from './webSocketMessageTypes.service';
export * from './withdrawController.service';
import { WithdrawControllerService } from './withdrawController.service';
export const APIS = [
  APIKeysControllerService,
  AssetsControllerService,
  BalancesControllerService,
  CandlesControllerService,
  CustomSettingControllerService,
  DepositControllerService,
  FiatDepositInstructionControllerService,
  LoginControllerService,
  OrdersControllerService,
  PairsControllerService,
  ReportingControllerService,
  StrategyControllerService,
  SubaccountTransferControllerService,
  TradingControllerService,
  TransfersControllerService,
  User2FAControllerService,
  UserControllerService,
  WebSocketMessageTypesService,
  WithdrawControllerService,
];
